import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "../../components/Select";

export default function BulkEditModal({ show, onHide, lookups, onSave }) {
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);

    const handleCategoryChange = (categoryId) => {
        setSelectedCategoryId(categoryId);
    };

    const handleTagsChange = (tagIds) => {
        setSelectedTags(tagIds);
    };

    const handleSave = () => {
        onSave({
            categoryId: selectedCategoryId,
            tags: selectedTags
        });
        handleClose();
    };

    const handleClose = () => {
        setSelectedCategoryId(null);
        setSelectedTags([]);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ direction: "rtl" }}>עריכה קבוצתית</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ direction: "rtl", padding: "30px" }}>
                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>קטגוריה</h5>
                    <Select
                        options={lookups?.categories || []}
                        selected={selectedCategoryId}
                        onSelect={handleCategoryChange}
                        closeOnSelect={true}
                        placeholder="בחר קטגוריה"
                        isSearchable={true}
                    />
                </div>

                <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ marginBottom: "15px", fontWeight: "bold" }}>תגיות</h5>
                    <Select
                        options={lookups?.tags || []}
                        selected={selectedTags}
                        onSelect={handleTagsChange}
                        multi={true}
                        placeholder="בחר תגיות"
                        isSearchable={true}
                    />
                </div>

                <div style={{ 
                    backgroundColor: "#f8f9fa", 
                    padding: "15px", 
                    borderRadius: "5px",
                    marginBottom: "20px"
                }}>
                    <p style={{ margin: 0, color: "#6c757d", fontSize: "14px" }}>
                        השינויים יחולו על כל השורות שנבחרו. 
                        אם לא תבחר קטגוריה או תגיות, הם לא ישתנו.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer style={{ direction: "rtl" }}>
                <Button variant="secondary" onClick={handleClose}>
                    ביטול
                </Button>
                <Button 
                    variant="primary" 
                    onClick={handleSave}
                    disabled={!selectedCategoryId && selectedTags.length === 0}
                >
                    שמור שינויים
                </Button>
            </Modal.Footer>
        </Modal>
    );
}